import styled from 'styled-components'
import { interpointDivider } from 'utilities/styled'
import { CaptionSmall } from 'components/typography/caption'

export const Items = styled(CaptionSmall)`
    ${interpointDivider()}
`